import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
// import Image from 'react-bootstrap/Image'
// import HeaderStripes from '../images/client/indy_steel_logo.png';
import styled from 'styled-components';

const BaseLogo = ({ data, className }) => (
  <div className={className}>
    <Link to='/'>
      <Img className="logo-rect" fluid={data.logo.childImageSharp.fluid} />
      <Img className="logo-square" fluid={data.logoSquare.childImageSharp.fluid} />
      {/* <img className="logo" src={HeaderStripes} alt={"Logo"}/> */}
      {/* <Image src={HeaderStripes} /> */}
    </Link>
  </div>
);

const Logo = styled(BaseLogo)`
  /* border: 1px solid red; */
  position: relative;
  /* display: flex; */
  /* align-self: flex-start; */
  padding-top: 25px;
  padding-left: 25px;
  background-color: #ffffff;
  min-width: 18%;
  img {
    align-self: flex-start;
    width: 100%;
    /* min-width: 50px; */
  }
  .logo-square{
    display: none;
  }
  @media screen and (max-width: 992px){
    .logo-rect {
      display: none
    }
    .logo-square {
      display: flex;
      min-width: 10vw;
    }
  }
  /* width: 100%; */
  /* height: 100%; */
  /* .logo {
    align-self: flex-start;
    bottom: 10%;
    position: relative;
    /* width: 100%; */
  
`;

export default props => (
  <StaticQuery
    query={graphql`
      query {
        logo: file(relativePath: { eq: "indy_steel_logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 212, srcSetBreakpoints: [50, 100, 150, 200]) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        logoSquare: file(relativePath: { eq: "indy_steel_logo_block.png" }) {
          childImageSharp {
            fluid(maxWidth: 200) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <Logo data={data} {...props} />}
  />
);
